module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Medium-0bf514904352445d78e6f83627b420c4.woff";